import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { faPlus, faUndo } from '@fortawesome/free-solid-svg-icons';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, switchMap, takeUntil } from 'rxjs/operators';
import { SideNavService, SidenavActions } from 'src/app/admin/services/side-nav.service';
import { BusinessDataService } from 'src/app/business/services/data.service';
import { DataService } from 'src/app/services/data.service';
import { ProfilePictureDialogComponent } from '../profile-picture-dialog/profile-picture-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import * as Parse from "parse";
import { Business } from 'backend/interfaces/business.interface';
import { Router } from '@angular/router';
@Component({
  selector: 'app-marketing',
  templateUrl: './marketing.component.html',
  styleUrls: ['./marketing.component.scss']
})
export class MarketingComponent implements OnInit, OnDestroy {
  @ViewChild('profilePic') profilePic: ElementRef;
  businesses = [];
  business;
  faUndo = faUndo;
  faPlus = faPlus;
  loading = false;
  leads;
  favoritedBy = [];
  selectedTabIndex = 0;
  private destroy$ = new Subject<void>();
  constructor(private dataService: BusinessDataService, private sideNavService: SideNavService, private dialog: MatDialog, private router: Router) { }

  isPending(): boolean {
    const isOwnedBusiness = this.businesses.some(business => business.id === this.business?.id);
    return isOwnedBusiness && (this.business?.Status || '').trim().toLowerCase() === 'pending';
  }

  completePayment(): void {
    this.router.navigate(['/user/onboarding'], {
      queryParams: { businessId: this.business.id, step: 'payment' }
    });
  }

  async ngOnInit(): Promise<void> {
    this.dataService.businesses$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(res => {
      if (res) this.businesses = res;
    });

    // React to every business switch — reload all tab data each time
    this.dataService.business$.pipe(
      takeUntil(this.destroy$),
      filter(b => !!b),
      distinctUntilChanged((a, b) => a?.id === b?.id)
    ).subscribe(async (business: Business) => {
      this.loading = true;
      this.business = business;
      this.favoritedBy = [];
      this.leads = [];
      // Reset tabs to Business Profile
      this.selectedTabIndex = 0;

      // Fetch favorites
      const usersArray = (business as any).FavoritedBy;
      if (usersArray && usersArray.length) {
        Parse.Cloud.run('getBusinessFavoritedBy', { usersArray }).then(res => {
          this.favoritedBy = res;
        });
      }

      // Fetch ads
      await this.dataService.getAdsByBusinessId(business.id);

      // Fetch leads
      if (business.Category?.id) {
        this.leads = await this.dataService.getLeadsForCategory(business.Category.id);
      }

      this.loading = false;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  createBusiness() {
    this.sideNavService.open(SidenavActions.NewBusiness);
  }

  async getAdsForBusiness(id: string) {
    this.loading = true;
    await this.dataService.getAdsByBusinessId(id);
    this.loading = false;
  }

  async getLeadsForCategory(categoryId: string) {
    this.loading = true;
    this.leads = await this.dataService.getLeadsForCategory(categoryId);
    this.loading = false;
  }

  openProfilePictureDialog(src?: any): void {
    const dialogRef = this.dialog.open(ProfilePictureDialogComponent, {
      data: { title: 'Upload Picture', parentId: this.business.id, currentPicture: src ? src : '' },
      width: '60%'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.profilePic.nativeElement.src = result;
      } else {
        this.dialog.closeAll();
      }
    });
  }

}
